import chooseNextProperId from 'helpers/chooseNextProperId'
import defaults from 'helpers/wiredDevices/defaults'

export default function duplicateWiredDevice(state, action) {
  const { id, location } = action
  const { entities: { wiredDevices: { allIds, byId } } } = state
  const wiredDevice = byId[id]

  if (!wiredDevice) return state

  const newId = chooseNextProperId(allIds)
  const typeCount = Object.values(byId).filter(device => device.type === wiredDevice.type).length + 1

  const newWiredDevice = Object.assign({}, defaults, wiredDevice, {
    name: `${wiredDevice.type} ${typeCount}`,
    location,
    id: newId,
    nameTouched: false
  })

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      wiredDevices: {
        byId: {
          ...state.entities.wiredDevices.byId,
          [newId]: newWiredDevice
        },
        allIds: allIds.concat(newId)
      }
    },
    currentEntity: {
      type: 'wiredDevice',
      id: newId
    },
    ui: {
      ...state.ui,
      sidebarView: 'wiredDeviceDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/duplicateWiredDevice.js